export default "/images/vendor/flag-icon-css/flags/4x3/un.svg?4c0a34afb0c02cd13b3df7aa133bed62";